module.exports = __webpack_public_path__ + "img/MeetUpHeader.3e99df81.jpg";